import isNil from 'lodash/isNil';
import sumBy from 'lodash/sumBy';

import { currencyFormatter } from 'utils';
import { percentageFormatter } from 'utils';

export const downloadFile = ({ response, file }) => {
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${file.name}`);
  document.body.appendChild(link);
  link.click();
  link.parentNode.removeChild(link);
};

export const downloadRequestHeaders = {
  responseType: 'arraybuffer',
  headers: {
    'Content-Type': 'application/json',
    Accept: `application/pdf`,
  },
};


// function calculateBusinessPlanDetails
// this function creates and initializes businessPlanDetails object from payload,
// we also use this function to get the list of properties in businessPlanDetails by
// calling it without a payload, e.g. Object.keys(calculateBusinessPlanDetails()),
// for this reason we first check if payload exists by using optional chaining operator (?.)
// and isNil()

export const calculateRestDetails = payload => {
  return {
    companySize: payload?.companySize,
    companyLegalType: payload?.companyLegalType,
    eligibilityCheck: payload?.eligibilityCheck,
    investmentPlanElements: payload?.investmentPlanElements,
  };
};

export const euroFormatter = new Intl.NumberFormat('el-GR', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 2,
});

export const printInfo = info => {
  // console.log("info:",info);
  if (typeof info === 'undefined' || info === null || info.length === 0) {
    return '-';
  } else {
    return info;
  }
};

export const printValue = info => {
  if (typeof info === 'undefined' || info === null || info.length === 0) {
    return '-';
  } else {
    return info + ' €';
  }
};

export const calculateBusinessPlanOverviewTables = payload => {
  //console.log(payload)
  return {
    InvestmentTotalAmountTable: isNil(payload) || isNil(payload.businessPlanDetails.businessPlanAssets)
      ? []
      : [
        {
          title: "Ιδία Συμμετοχή/Ενισχύσεις",
          percentage: percentageFormatter(
            (
              (
                sumBy(payload.businessPlanDetails.businessPlanAssets, 'totalPrice')
                - sumBy(payload.businessPlanDetails.businessPlanAssets, 'businessLoan')
                - sumBy(payload.businessPlanDetails.businessPlanAssets, 'rrfLoan')

              )
              /
              sumBy(payload.businessPlanDetails.businessPlanAssets, 'totalPrice')

            ) * 100
          ),
          SumTotalExpense: currencyFormatter(
            sumBy(payload.businessPlanDetails.businessPlanAssets, 'totalPrice')
            - sumBy(payload.businessPlanDetails.businessPlanAssets, 'publicExp')
          )
        },
        {
          title: "Εμπορικό Δάνειο",
          percentage: percentageFormatter(
            (
              sumBy(payload.businessPlanDetails.businessPlanAssets, 'businessLoan')
              /
              sumBy(payload.businessPlanDetails.businessPlanAssets, 'totalPrice')

            ) * 100
          ),
          SumTotalExpense: currencyFormatter(
            sumBy(payload.businessPlanDetails.businessPlanAssets, 'businessLoan')
          )
        },
        {
          title: "Δάνειο ΤΑΑ",
          percentage: percentageFormatter(
            (
              sumBy(payload.businessPlanDetails.businessPlanAssets, 'rrfLoan')
              /
              sumBy(payload.businessPlanDetails.businessPlanAssets, 'totalPrice')

            ) * 100
          ),
          SumTotalExpense: currencyFormatter(
            sumBy(payload.businessPlanDetails.businessPlanAssets, 'rrfLoan')
          )
        },
        {
          title: "Σύνολο",
          percentage:  sumBy(payload.businessPlanDetails.businessPlanAssets, 'totalPrice') == 0 ? '0,00 %' : "100,00 %",
          SumTotalExpense: currencyFormatter(
            sumBy(payload.businessPlanDetails.businessPlanAssets, 'totalPrice')
          )
        },
      ]
  }
}